import React, { useState, forwardRef } from 'react';
import './floating-label-input.scss';

const FloatingLabelInput = forwardRef(
  (
    { id,
      label,
      value,
      onChange,
      rtl = true,
      required = true,
      isInvalid = false,
      errorMessage = '',
      autoComplete = true,
      type = 'text',
      ...rest
    },
    ref
  ) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    return (
      <div className={`floating-label-input ${rtl ? 'rtl' : ''} ${isInvalid ? 'invalid' : ''}`}>
        <input
          id={id}
          ref={ref}
          type={type}
          aria-label={label}
          aria-required="true"
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          autoComplete={autoComplete}
          {...rest}
        />
        <label className={(isFocused || value) ? 'float' : ''} htmlFor={id}>
          {required && '*'}{label}
        </label>
        {isInvalid && errorMessage && (
          <div className="error-description">{errorMessage}</div>
        )}
      </div>
    );
  }
);

export default FloatingLabelInput;
